import Informacion from "../components/Informacion";

import investiga from "../img/investiga/investiga.gif";
function Home() {
  return (
  <>
  <div className="mt-10" id="inicio">  <img src={investiga}></img></div>

  <Informacion></Informacion></>
  );
}

export default Home;
